import { Suspense, lazy } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import ThreeDotLoader from "../Utils/ThreeDotLoader";

import LoginComponent from "../Component/Login/LoginComp/Login";
// const LoginComponent = lazy(() => import("../Component/Login/LoginComp/Login"));
const ForgotComp = lazy(() => import("../Component/Login/Forgotpw/Forgot"));
const InProgress = lazy(() => import("../Pages/InProgress/InProgress"));
const ChangePassword = lazy(() =>
  import("../Component/changePassword/changepass")
);
const SuperAdmin = lazy(() => import("../Component/SuperAdmin/SuperAdmin"));
const SuperadmincommunityComp = lazy(() =>
  import("../Component/SuperAdmin/Superadmincommunity/Superadmincommunity")
);
const CreatecommunityComp = lazy(() =>
  import("../Component/CreateCommunity/Createcommunity")
);
const UpdatecommunityComp = lazy(() =>
  import("../Component/updateCommunity/Updatecommunity")
);
const DashboardpageComp = lazy(() =>
  import("../Component/Dashboard/Dashboard")
);
const TabsComponent = lazy(() => import("../Component/Tabs/Tabs"));
const SuperadminprofileComp = lazy(() =>
  import("../Component/SuperAdmin/SuperAdminProfile/Superadminprofile")
);
const UploadDocument = lazy(() =>
  import("../Component/UploadDocument/UploadDocument")
);
const UpdateProfile = lazy(() =>
  import("../Component/updateProfile/updateProfile")
);
const Superadminclaimcomp = lazy(() =>
  import("../Component/SuperAdmin/SuperadminClaim/Superadminclaim")
);
const Usermanagement = lazy(() =>
  import("../Component/User Management/Usermanagement")
);
const ViewUserProfile = lazy(() =>
  import("../Component/User Management/ViewUserProfile/ViewUserProfile")
);
const TrainAI = lazy(() =>
  import("../Component/SuperAdmin/TrainAInew/TrainAI")
);
const SuperadminApproval = lazy(() =>
  import("../Component/SuperAdmin/SuperadminApproval/SuperadminApproval")
);
const DocumentApproval = lazy(() =>
  import(
    "../Component/SuperAdmin/SuperadminApproval/DocumentApproval/DocumentApproval"
  )
);
const FactCheckApproval = lazy(() =>
  import(
    "../Component/SuperAdmin/SuperadminApproval/FactCheckApproval/FactCheckApproval"
  )
);
const SuperadminLargeCommunities = lazy(() =>
  import(
    "../Component/SuperAdmin/SuperadminLargeCommunities/SuperadminLargeCommunities"
  )
);
const Payment = lazy(() =>
  import("../Component/Billing Pages/Payments/Payment")
);
const Reports = lazy(() =>
  import("../Component/Billing Pages/Reports/Reports")
);
const SubscriptionPlans = lazy(() =>
  import("../Component/Billing Pages/Subscription Plans/Subscriptionplan")
);
const Knowledge = lazy(() =>
  import("../Component/SuperAdmin/TrainAI/Knowledge/Knowledge")
);
const BoardRequirements = lazy(() =>
  import(
    "../Component/SuperAdmin/SuperadminStatic/BoardRequirements/BoardRequirements"
  )
);
const CertificationClasses = lazy(() =>
  import(
    "../Component/SuperAdmin/SuperadminStatic/CertificationClasses/CertificationClasses"
  )
);
const Compliance = lazy(() =>
  import("../Component/SuperAdmin/Compliance/Compliance")
);
const DocumentTable = lazy(() =>
  import("../Component/SuperAdmin/Compliance/Documents/DocumentTable")
);
const Analyze = lazy(() =>
  import("../Component/SuperAdmin/Compliance/Analyze/Analyze")
);
const Laws = lazy(() => import("../Component/SuperAdmin/Compliance/Laws/Laws"));
const Insurance = lazy(() =>
  import("../Component/SuperAdmin/Compliance/Insurance/Insurance")
);
const Finance = lazy(() =>
  import("../Component/SuperAdmin/Compliance/Finance/Finance")
);
const Board = lazy(() =>
  import("../Component/SuperAdmin/Compliance/Board/Board")
);
const BoardMembersList = lazy(() =>
  import(
    "../Component/SuperAdmin/Compliance/Board/BoardMembersList/BoardMembersList"
  )
);
const AddBoardMemberForm = lazy(() =>
  import(
    "../Component/SuperAdmin/Compliance/Board/AddBoardMemberForm/AddBoardMemberForm"
  )
);
const BoardRequirementsCompliance = lazy(() =>
  import(
    "../Component/SuperAdmin/Compliance/Board/BoardRequirements/BoardRequirements"
  )
);
const Rating = lazy(() =>
  import("../Component/SuperAdmin/Compliance/Rating/Rating")
);
const ScoringModels = lazy(() =>
  import("../Component/SuperAdmin/Compliance/Rating/ScoringModel/ScoringModels")
);
const CreateEditScoringModel = lazy(() =>
  import(
    "../Component/SuperAdmin/Compliance/Rating/ScoringModel/CreateEditScoringModel"
  )
);
const HomeOwnerList = lazy(() =>
  import(
    "../Component/SuperAdmin/Superadmincommunity/HomeOwnerList/HomeOwnerList"
  )
);
const StaticRiskMitigation = lazy(() =>
  import(
    "../Component/SuperAdmin/SuperadminStatic/RiskMitigation/RiskMitigation"
  )
);
const StaticPreparednessResources = lazy(() =>
  import(
    "../Component/SuperAdmin/SuperadminStatic/PreparednessResources/PreparednessResources"
  )
);
const EmergencyResponder = lazy(() =>
  import(
    "../Component/SuperAdmin/SuperadminStatic/EmergencyResponder/EmergencyResponder"
  )
);
const CertifiedVendors = lazy(() =>
  import(
    "../Component/SuperAdmin/SuperadminStatic/CertifiedVendors/CertifiedVendors"
  )
);
const Access = lazy(() =>
  import("../Component/SuperAdmin/Compliance/Access/Access")
);
const AddEditUser = lazy(() =>
  import("../Component/SuperAdmin/Compliance/Access/AddEditUser/AddEditUser")
);
const Emergency = lazy(() =>
  import("../Component/SuperAdmin/Compliance/Emergency/Emergency")
);
const EmergencyContacts = lazy(() =>
  import(
    "../Component/SuperAdmin/Compliance/Emergency/EmergencyContacts/EmergencyContacts"
  )
);
const PreparednessResources = lazy(() =>
  import(
    "../Component/SuperAdmin/Compliance/Emergency/PreparednessResources/PreparednessResources"
  )
);
const RiskMitigation = lazy(() =>
  import(
    "../Component/SuperAdmin/Compliance/Emergency/RiskMitigation/RiskMitigation"
  )
);
const EmergencyBroadcast = lazy(() =>
  import(
    "../Component/SuperAdmin/Compliance/Emergency/EmergencyBroadcast/EmergencyBroadcast"
  )
);
const Calendar = lazy(() =>
  import("../Component/SuperAdmin/Compliance/Calendar/Calendar")
);
const Maintanance = lazy(() =>
  import("../Component/SuperAdmin/Compliance/Maintanance/Maintanance")
);

const AppRoutes = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            <Suspense fallback={<ThreeDotLoader />}>
              <LoginComponent />
            </Suspense>
          }
        />
        <Route
          path="/forgot-password"
          element={
            <Suspense fallback={<ThreeDotLoader />}>
              <ForgotComp />
            </Suspense>
          }
        />
        <Route
          path="/inprogress"
          element={
            <Suspense fallback={<ThreeDotLoader />}>
              <InProgress />
            </Suspense>
          }
        />
        <Route
          path="/change-password"
          element={
            <Suspense fallback={<ThreeDotLoader />}>
              <ChangePassword />
            </Suspense>
          }
        />
        <Route
          path="/super-admin"
          element={
            <Suspense fallback={<ThreeDotLoader />}>
              <SuperAdmin />
            </Suspense>
          }
        >
          <Route
            path="super-admin-community-comp"
            element={<SuperadmincommunityComp />}
          />
          <Route path="create-community" element={<CreatecommunityComp />} />
          <Route path="update-community" element={<UpdatecommunityComp />} />
          <Route path="dashboard" element={<DashboardpageComp />} />
          <Route path="tab" element={<TabsComponent />} />
          <Route path="tab/:encryptedId" element={<TabsComponent />} />
          <Route path="inprogress" element={<InProgress />} />
          <Route
            path="super-admin-profile"
            element={<SuperadminprofileComp />}
          />
          <Route path="upload-document" element={<UploadDocument />} />
          <Route path="update-profile" element={<UpdateProfile />} />
          <Route path="super-admin-claim" element={<Superadminclaimcomp />} />
          <Route path="user-management" element={<Usermanagement />} />
          <Route path="view-user-profile/:id" element={<ViewUserProfile />} />
          <Route path="approval" element={<SuperadminApproval />} />
          <Route path="training-Ai" element={<TrainAI />} />
          <Route path="fact-check-approval" element={<FactCheckApproval />} />
          <Route path="document-approval" element={<DocumentApproval />} />
          <Route path="ai-knowledge" element={<Knowledge />} />
          <Route path="payments" element={<Payment />} />
          <Route path="reports" element={<Reports />} />
          <Route path="subscriptions" element={<SubscriptionPlans />} />
          <Route
            path="super-admin-groups"
            element={<SuperadminLargeCommunities />}
          />
          <Route path="board-requirements" element={<BoardRequirements />} />
          <Route
            path="certification-classes"
            element={<CertificationClasses />}
          />
          <Route path="homeowner-list" element={<HomeOwnerList />} />
          <Route path="compliance/:communityId" element={<Compliance />}>
            <Route index element={<Navigate to="documents" replace />} />
            <Route path="documents" element={<DocumentTable />} />
            <Route path="analyze" element={<Analyze />} />
            <Route path="analyze/:categoryId" element={<Analyze />} />
            <Route path="laws" element={<Laws />} />
            <Route path="rating" element={<Rating />} />
            <Route path="rating/scoring-model" element={<ScoringModels />} />
            <Route
              path="rating/create-scoring-model"
              element={<CreateEditScoringModel />}
            />
            <Route
              path="rating/edit-scoring-model/:id"
              element={<CreateEditScoringModel />}
            />
            <Route path="board" element={<Board />}>
              <Route path="board-member-list" element={<BoardMembersList />} />
              <Route path="add-board-member" element={<AddBoardMemberForm />} />
              <Route
                path="board-requirements"
                element={<BoardRequirementsCompliance />}
              />
              <Route
                path="update-board-member/:id"
                element={<AddBoardMemberForm />}
              />
            </Route>
            <Route path="insurance" element={<Insurance />} />
            <Route path="finance" element={<Finance />} />
            <Route path="access" element={<Access />} />
            <Route path="access/add-user" element={<AddEditUser />} />
            <Route path="access/edit-user/:id" element={<AddEditUser />} />
            <Route path="emergency" element={<Emergency />} />
            <Route
              path="emergency/emergency-contacts"
              element={<EmergencyContacts />}
            />
            <Route
              path="emergency/preparedness-resources"
              element={<PreparednessResources />}
            />
            <Route
              path="emergency/riskmitigation"
              element={<RiskMitigation />}
            />
            <Route
              path="emergency/emergency-responder"
              element={<EmergencyBroadcast />}
            />
            <Route path="calendar" element={<Calendar />} />
            <Route path="maintanance" element={<Maintanance />} />
          </Route>
          <Route path="risk-mitigation" element={<StaticRiskMitigation />} />
          <Route
            path="preparedness-resources"
            element={<StaticPreparednessResources />}
          />
          <Route path="emergency-responders" element={<EmergencyResponder />} />
          <Route path="certified-vendors" element={<CertifiedVendors />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default AppRoutes;
